import React from "react";
import axios from "axios";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { TextField, Button, Container, InputLabel, Select, MenuItem } from "@material-ui/core";
import Table from "literacy/components/tutor/thread-data-table/blank-table";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class MeaningData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      qW1: [],
      qW2: [],
      qAccess: [],
      question: "",
      answer: "",
      hint: "",
      alert: false,
      section: "w1"
    };
  }

  componentDidMount = async () => {
    const doc1 = await axios.get("/api/literacy/meaning/blank/w1");
    const doc2 = await axios.get("/api/literacy/meaning/blank/w2");
    const doc3 = await axios.get("/api/literacy/meaning/blank/access");
    if (doc1.data) {
      this.setState({ qW1: doc1.data });
    }
    if (doc2.data) {
      this.setState({ qW2: doc2.data });
    }
    if (doc3.data) {
      this.setState({ qAccess: doc3.data });
    }
  };

  addData = async () => {
    const { question, answer, section, hint } = this.state;
    await axios.post("/api/literacy/meaning/blank", {
      question, answer, version: section, hint
    });
    await this.setState({ question: "", answer: "", hint: "" });
    this.componentDidMount();
  };

  handleEdit = async (id, newRow) => {
    await axios.put("/api/literacy/meaning/blank/" + id, newRow);
    this.componentDidMount();
  }

  deleteData = async (id) => {
    await axios.delete("/api/literacy/meaning/blank/" + id);
    this.componentDidMount();
  };

  handleSectionChange = (e) => {
    this.setState({ section: e.target.value });
  }

  renderTable = () => {
    const { section, qW1, qW2, qAccess } = this.state;
    switch (section) {
      case "w1":
        return <Container>
          <Table rows={qW1} onEdit={this.handleEdit} handleDelete={this.deleteData} />
        </Container>
      case "w2":
        return <Container>
          <Table rows={qW2} onEdit={this.handleEdit} handleDelete={this.deleteData} />
        </Container>
    }
  }

  render() {
    const { section, question, answer, alert, hint } = this.state;

    return (
      <div>
        <div className="jumbotron">
          <h2>Modify Meaning Blank Question Data</h2>
          <br />
          <Button variant="contained" style={{ color: "white", backgroundColor: "#107896" }} href="/literacy/tutor/meaning">
            Go back
          </Button>
        </div>
        <Container>
          <InputLabel id="label">Assignment Section</InputLabel>
          <Select
            labelId="demo-controlled-open-select-label"
            id="demo-controlled-open-select"
            value={section}
            onChange={this.handleSectionChange}
          >
            <MenuItem value="w1">Week 1</MenuItem>
            <MenuItem value="w2">Week 2</MenuItem>
          </Select>
        </Container>
        <Container>
          <h5>
            Example: When we combine the sounds /n/, /oi/ and /s/, it makes the word ____.
          </h5>
          <h5>Answer: noise</h5>
          <TextField
            label="question"
            style={{ width: 520 }}
            autoComplete="off"
            value={question}
            onChange={(e) => this.setState({ question: e.target.value })}
          />
          <br />
          <TextField
            label="answer"
            autoComplete="off"
            value={answer}
            style={{ width: 200 }}
            onChange={(e) => this.setState({ answer: e.target.value })}
          />
          <TextField
            label="Hint"
            autoComplete="off"
            value={hint}
            style={{ width: 300, marginLeft: 20 }}
            onChange={(e) => this.setState({ hint: e.target.value })}
          />
          <br />
          <Button
            variant="contained"
            style={{ marginTop: 10, color: "white", backgroundColor: "#107896" }}
            onClick={this.addData}
          >
            Add
          </Button>
        </Container>
        <br />
        <br />
        {this.renderTable()}
        <br />
        <br />
        <Snackbar
          open={alert}
          autoHideDuration={2000}
          onClose={this.handleCloseAlert}
        >
          <Alert onClose={this.handleClose} severity="success">
            Operation Successfully!
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

export default MeaningData;
